<template>
  <div class="login-page">
    <div class="landing-page-edit-panel"
         v-if="isGM()">
      <div class="wrapper" :class="[{ 'active': landingPanel }]">
        <div class="landing-page-edit-settings" @click.prevent="landingPanel = !landingPanel"></div>
        <div v-if="editHistory === false">
          <div class="action-btn"
               @click.prevent="pageMetaEdit = true">Edit page meta</div>
          <div class="action-btn"
               v-if="pageEditMode === false"
               @click.prevent="pageEditSwitch()">Edit page content</div>
          <div class="action-btn"
               @click.prevent="activateEditHistory()">Page edit history</div>
        </div>
        <div v-if="editHistory === true">
          <div class="form-group">
            <div class="form-element">
              <label for="page-versions" class="form-label color-2-63">Page save history</label>
              <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                        :searchable = false
                        @input="changeLandingPage($event)"
                        :options="getPageVersionsForSelect()"
                        data-lpignore="true"
                        id="page-versions" />
            </div>
          </div>
        </div>
        <div class="action-btn-bottom">
          <div class="action-btn action-btn-save"
               v-if="pageEditMode === true"
               @click.prevent="updateLandingPage()">Save</div>
          <div class="action-btn action-btn-discard"
               @click.prevent="discardPageEdit()">Discard</div>
        </div>
      </div>
    </div>
    <div class="wrapper" style="overflow: hidden;">
      <div class="inform-popup success"
           id="information-message"
           ref="informationMsg"
           v-if="activatePage">
        <div class="inform-message-inner">
          <div class="inform-title">
            Your account was successfully activated.
          </div>
          <div class="inform-content">
            Please use the temporary credentials from your invitation email to login.
          </div>
          <a href="#" v-on:click.prevent="closeCustomMsg()" class="inform-close"></a>
        </div>
      </div>
      <div class="landing-page-wrapper login-hero"
           v-show="!content.heroSection.hideSection || content.heroSection.hideSection === 'null' || (pageEditMode && isGM())">
        <div class="landing-page-hero-image"
             :title="content.heroSection.altImage"
             v-bind:style="{ backgroundImage: getImage(content.heroSection.image) }">
          <input type="text"
                 placeholder="Alt image"
                 v-if="pageEditMode && isGM()"
                 class="landing-page-image-alt"
                 v-model="content.heroSection.altImage" />
        </div>
        <label :for="'hero-image-upload'"
               v-if="pageEditMode && isGM()"
               class="hero-upload"></label>
        <input type="file"
               v-if="pageEditMode && isGM()"
               @change="onFileChange($event, content.heroSection, 'image')"
               :id="'hero-image-upload'" />
        <div class="landing-page-content">
          <div class="toggle-section-visibility"
               v-if="pageEditMode && isGM()">
            <input type="checkbox"
                   class="form-control__checkbox"
                   id="showHero"
                   v-model="content.heroSection.hideSection" />
            <label for="showHero">Hide this section</label>
          </div>
          <div class="landing-page-section">
            <div class="landing-page-hero">
              <h1 class="landing-page-title color-1-100" v-if="!pageEditMode">
                {{ content.heroSection.title }}
              </h1>
              <textarea class="landing-page-title color-1-100"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section title"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.heroSection.title"
                        v-on:keydown="autoSize($event)">{{ content.heroSection.title }}</textarea>
              <h2 class="landing-page-description" v-if="!pageEditMode">
                {{ content.heroSection.description }}
              </h2>
              <textarea class="landing-page-description"
                        v-if="pageEditMode && isGM()"
                        data-gramm_editor="false"
                        placeholder="Section description"
                        data-lpignore="true"
                        rows="1"
                        v-model="content.heroSection.description"
                        v-on:keydown="autoSize($event)">{{ content.heroSection.description }}</textarea>
              <form v-on:submit="authenticate('top')">
                <div class="landing-page-login-wrapper">
                  <div class="landing-page-login-group"
                       :class="[{ 'active': topLoginForm.email !== '' || topLoginForm.emailFocus, 'has-error': topLoginForm.isError || errors.has('TopEmail') }]">
                    <label for="landing-page-login-email">Email</label>
                    <input id="landing-page-login-email"
                           :class="[{ 'border-1-50': topLoginForm.email !== '' || topLoginForm.emailFocus }]"
                           type="email"
                           @keyup.enter="authenticate('top')"
                           @focus="topLoginForm.emailFocus = true"
                           @blur="topLoginForm.emailFocus = false"
                           v-validate="'required|email'"
                           data-vv-name="TopEmail"
                           v-model="topLoginForm.email" />
                  </div>
                  <div class="landing-page-login-group"
                       :class="[{ 'active': topLoginForm.password !== '' || topLoginForm.passwordFocus, 'has-error': topLoginForm.isError || errors.has('TopPassword') }]">
                    <label for="landing-page-login-password">Password</label>
                    <span class="landing-page-login-password-show"
                          @click.prevent="showPassword('top')"></span>
                    <input id="landing-page-login-password"
                           :class="[{ 'border-1-50': topLoginForm.password !== '' || topLoginForm.passwordFocus }]"
                           @keyup.enter="authenticate('top')"
                           :type="topLoginForm.passwordType"
                           @focus="topLoginForm.passwordFocus = true"
                           @blur="topLoginForm.passwordFocus = false"
                           v-validate="'required'"
                           data-vv-name="TopPassword"
                           v-model="topLoginForm.password" />
                  </div>
                  <div class="login-form-error"
                       aria-live="assertive">
                    <span v-if="this.topLoginForm.loginInProgress"
                          class="login-form-error-container visually-hidden">Submitting</span>
                    <template v-else>
                      <div class="login-form-error-container" v-if="this.errors.has('TopEmail') || this.errors.has('TopPassword') || this.topLoginForm.loginErrorMessage">
                        <span v-if="this.errors.has('TopEmail')">{{ removeWordFromString('Top', this.errors.first('TopEmail')) }}</span><br/>
                        <span v-if="this.errors.has('TopPassword')">{{ removeWordFromString('Top', this.errors.first('TopPassword')) }}</span><br/>
                        <span v-if="this.topLoginForm.loginErrorMessage">{{ this.topLoginForm.loginErrorMessage }}</span>
                      </div>
                    </template>
                  </div>
                  <div class="landing-page-login-actions">
                    <button type="submit" class="login background-1-100"
                            :class="[{ 'active-logging': topLoginForm.loginInProgress }]"
                            @click.prevent="authenticate('top')">Login</button>
                    <router-link :to="{ name: 'forgot-password' }" class="reset-password">Forgot password?</router-link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="landing-page-wrapper login-steps landing-page-wrapper-gray"
           v-show="!content.stepSection.hideSection || content.stepSection.hideSection === 'null' || (pageEditMode && isGM())">
        <div class="landing-page-shadow"></div>
        <div class="landing-page-content background-1-100-before">
          <div class="toggle-section-visibility"
               v-if="pageEditMode && isGM()">
            <input type="checkbox"
                   class="form-control__checkbox"
                   id="showStep"
                   v-model="content.stepSection.hideSection" />
            <label for="showStep">Hide this section</label>
          </div>
          <div class="landing-page-steps-text color-2-77"
               v-if="!pageEditMode"
               :aria-label="decodeHtml(content.stepSection.description) | striphtml"
               v-html="decodeHtml(content.stepSection.description)"></div>
          <textarea class="landing-page-steps-text color-2-77"
                    data-gramm_editor="false"
                    placeholder="Section description"
                    data-lpignore="true"
                    v-if="pageEditMode && isGM()"
                    rows="1"
                    v-model="content.stepSection.description"
                    v-on:keydown="autoSize($event)">{{ decodeHtml(content.stepSection.description) }}</textarea>
          <div class="landing-page-steps-wrapper" ref="steps">
            <div class="step-item"
                 :class="[{ 'step-active': stepActive === (index + 1) }, 'step__' + step.id]"
                 v-for="(step, index) in content.stepSection.steps">
              <div class="step-item-content" v-if="!pageEditMode">
                {{ step.text }}
              </div>
              <textarea class="step-item-content"
                        data-gramm_editor="false"
                        data-lpignore="true"
                        placeholder="Step item text"
                        v-if="pageEditMode && isGM()"
                        rows="1"
                        v-model="step.text"
                        v-on:keydown="autoSize($event)">{{ step.text }}</textarea>
              <div class="step-item-image"
                   @click.prevent.stop="activatePopup(step)"
                   :title="step.altImage"
                   v-bind:style="{ backgroundImage: getImage(getHighImage(step)) }">
                <span class="step-item-upload" v-if="pageEditMode && isGM()"></span>
              </div>
            </div>
            <div class="landing-page-steps-pagination" v-if="getDeviceType('mobile')">
              <span class="step-item__1"
                    :class="[{ 'active': stepActive === 1 }]" @click.prevent="stepActive = 1"></span>
              <span class="step-item__2"
                    :class="[{ 'active': stepActive === 2 }]" @click.prevent="stepActive = 2"></span>
              <span class="step-item__3"
                    :class="[{ 'active': stepActive === 3 }]" @click.prevent="stepActive = 3"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="landing-page-wrapper login-text-sections landing-page-wrapper-gray"
           v-show="content.textSection.length || (pageEditMode && isGM())"
           v-if="content.textSection.length">
        <div class="landing-page-content">
          <div class="login-text-section-group"
               v-for="(item, index) in content.textSection">
            <div class="login-text-section-image"
                 v-if="!getDeviceType('mobile')"
                 :title="item.altImage"
                 v-bind:style="{ backgroundImage: getImage(item.image) }">
              <input type="text"
                     placeholder="Alt image"
                     v-if="pageEditMode && isGM()"
                     class="landing-page-image-alt"
                     v-model="item.altImage" />
            </div>
            <div class="login-text-section-content">
              <div class="login-text-section-content__title color-1-100" v-if="!pageEditMode">
                {{ item.title }}
              </div>
              <div class="login-text-section-image"
                   v-if="getDeviceType('mobile')"
                   :title="item.altImage"
                   v-bind:style="{ backgroundImage: getImage(item.image) }">
                <input type="text"
                       placeholder="Alt image"
                       v-if="pageEditMode && isGM()"
                       class="landing-page-image-alt"
                       v-model="item.altImage" />
              </div>
              <textarea class="login-text-section-content__title color-1-100"
                        data-gramm_editor="false"
                        data-lpignore="true"
                        placeholder="Section title"
                        v-if="pageEditMode && isGM()"
                        rows="1"
                        v-model="item.title"
                        v-on:keydown="autoSize($event)">{{ item.title }}</textarea>
              <div class="login-text-section-content__description color-2-77" v-if="!pageEditMode">
                {{ item.text }}
              </div>
              <textarea class="login-text-section-content__description color-2-77"
                        data-gramm_editor="false"
                        data-lpignore="true"
                        placeholder="Section description"
                        v-if="pageEditMode && isGM()"
                        rows="1"
                        v-model="item.text"
                        v-on:keydown="autoSize($event)">{{ item.text }}</textarea>
            </div>
            <label :for="'section-text-image-upload' + index"
                   v-if="pageEditMode && isGM()"
                   class="login-text-section-upload"></label>
            <input type="file"
                   v-if="pageEditMode && isGM()"
                   @change="onFileChange($event, item, 'image')"
                   :id="'section-text-image-upload' + index" />
            <div class="login-text-section-remove"
                 v-if="pageEditMode && isGM()"
                 @click.prevent="removeSection(content.textSection, index)"></div>
            <div class="clearfix"></div>
          </div>
          <div class="landing-page-add-section"
               @click.prevent="addSection(content.textSection)"
               v-if="pageEditMode && isGM()">+ Add row</div>
        </div>
      </div>
      <div class="landing-page-wrapper login-cta"
           v-show="!content.ctaSection.hideSection || content.ctaSection.hideSection === 'null' || (pageEditMode && isGM())">
        <div class="landing-page-content">
          <div class="toggle-section-visibility"
               v-if="pageEditMode && isGM()">
            <input type="checkbox"
                   class="form-control__checkbox"
                   id="showCTA"
                   v-model="content.ctaSection.hideSection" />
            <label for="showCTA">Hide this section</label>
          </div>
          <h2 class="landing-page-login-cta__head color-2-63"
               v-if="!pageEditMode"
               v-html="decodeHtml(content.ctaSection.title)"></h2>
          <textarea class="landing-page-login-cta__head color-2-63"
                    data-gramm_editor="false"
                    placeholder="Section title"
                    data-lpignore="true"
                    v-if="pageEditMode && isGM()"
                    rows="1"
                    v-model="content.ctaSection.title"
                    v-on:keydown="autoSize($event)">{{ decodeHtml(content.ctaSection.title) }}</textarea>
          <div class="landing-page-login-cta__form">
            <form v-on:submit="authenticate('bottom')">
              <div class="landing-page-login-wrapper">
                <div class="landing-page-login-group"
                     :class="[{ 'active': bottomLoginForm.email !== '' || bottomLoginForm.emailFocus, 'has-error': bottomLoginForm.isError || errors.has('BottomEmail') }]">
                  <label for="landing-page-cta-login-email">Email</label>
                  <input id="landing-page-cta-login-email"
                         :class="[{ 'border-1-50': bottomLoginForm.email !== '' || bottomLoginForm.emailFocus }]"
                         type="email"
                         @keyup.enter="authenticate('bottom')"
                         @focus="bottomLoginForm.emailFocus = true"
                         @blur="bottomLoginForm.emailFocus = false"
                         v-validate="'required|email'"
                         data-vv-name="BottomEmail"
                         v-model="bottomLoginForm.email" />
                </div>
                <div class="landing-page-login-group"
                     :class="[{ 'active': bottomLoginForm.password !== '' || bottomLoginForm.passwordFocus, 'has-error': bottomLoginForm.isError || errors.has('BottomPassword') }]">
                  <label for="landing-page-cta-login-password">Password</label>
                  <span class="landing-page-login-password-show"
                        @click.prevent="showPassword('bottom')"></span>
                  <input id="landing-page-cta-login-password"
                         :class="[{ 'border-1-50': bottomLoginForm.password !== '' || bottomLoginForm.passwordFocus }]"
                         :type="bottomLoginForm.passwordType"
                         @keyup.enter="authenticate('bottom')"
                         @focus="bottomLoginForm.passwordFocus = true"
                         @blur="bottomLoginForm.passwordFocus = false"
                         v-validate="'required'"
                         data-vv-name="BottomPassword"
                         v-model="bottomLoginForm.password" />
                </div>
                <div class="login-form-error"
                     aria-live="assertive">
                  <span v-if="this.bottomLoginForm.loginInProgress"
                        class="login-form-error-container visually-hidden">Submitting</span>
                  <template v-else>
                    <div class="login-form-error-container" v-if="this.errors.has('BottomEmail') || this.errors.has('BottomPassword') || this.bottomLoginForm.loginErrorMessage">
                      <span v-if="this.errors.has('BottomEmail')">{{ removeWordFromString('Bottom', this.errors.first('BottomEmail')) }}</span><br/>
                      <span v-if="this.errors.has('BottomPassword')">{{ removeWordFromString('Bottom', this.errors.first('BottomPassword')) }}</span><br/>
                      <span v-if="this.bottomLoginForm.loginErrorMessage">{{ this.bottomLoginForm.loginErrorMessage }}</span>
                    </div>
                  </template>
                </div>
                <div class="landing-page-login-actions">
                  <button type="submit" class="login background-1-100"
                          :class="[{ 'active-logging': bottomLoginForm.loginInProgress }]"
                          @click.prevent="authenticate('bottom')">Login</button>
                  <router-link :to="{ name: 'forgot-password' }" class="reset-password">Forgot password?</router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="landing-page-change-image" v-if="activePopup && pageEditMode && isGM()">
        <div class="modal-inner" ref="popup">
          <h1>Upload icons</h1>
          <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
          <div class="modal-item">
            <h2>Image (normal)</h2>
            <div class="modal-image"
                 v-bind:style="{ backgroundImage: getImage(activePopup.image) }">
              <label for="popup-step-image-upload"
                     class="step-item-upload"></label>
              <input type="file"
                     @change="onFileChange($event, activePopup, 'image')"
                     id="popup-step-image-upload" />
            </div>
            <input type="text" v-model="activePopup.altImage" placeholder="Image alt" />
          </div>
          <div class="modal-item">
            <h2>Image (high contrast)</h2>
            <div class="modal-image"
                 v-bind:style="{ backgroundImage: getImage(activePopup.imageHigh) }">
              <label for="popup-step-high-image-upload"
                     class="step-item-upload"></label>
              <input type="file"
                     @change="onFileChange($event, activePopup, 'imageHigh')"
                     id="popup-step-high-image-upload" />
            </div>
            <input type="text" v-model="activePopup.altImageHigh" placeholder="High contrast image alt" />
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
    <div class="landing-page-change-image" v-if="pageMetaEdit && isGM()">
      <div class="modal-inner" ref="metaEditPopup">
        <h1>Change page meta</h1>
        <a href="#" class="modal-close" @click.prevent="closePopup()"></a>
        <div class="popup-footer-edit">
          <div>
            <div class="meta-description">
              <label for="meta-title">Title</label>
              <input id="meta-title"
                     placeholder="Page meta title"
                     v-model="metaData.title" />
            </div>
            <div class="meta-description">
              <label for="meta-description">Description</label>
              <textarea id="meta-description"
                        placeholder="Page meta description"
                        v-model="metaData.description">{{ metaData.description }}</textarea>
            </div>
          </div>
        </div>
        <div class="popup-actions">
          <a href="#" @click.prevent="closePopup()" class="discard">Discard</a>
          <a href="#" @click.prevent="updateMeta()" class="submit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'

export default {
  name: 'login',
  data () {
    return {
      pageEditMode: false,
      landingPanel: false,
      pageMetaEdit: false,
      editHistory: false,
      pageVersions: [],
      metaData: {
        title: '',
        description: ''
      },
      topLoginForm: {
        email: '',
        password: '',
        grantType: 'password',
        clientId: '2_659vq9a3czggcws88wcws8s4kc8gc8gcss4wog4cwcsk08ggkg',
        clientSecret: '5ncmjzrt9ps8808cskk8ogwwgwkgks8ggc0kskg0cw48s08ks4',
        emailFocus: false,
        passwordFocus: false,
        loginInProgress: false,
        isError: false,
        loginErrorMessage: '',
        passwordType: 'password'
      },
      bottomLoginForm: {
        email: '',
        password: '',
        grantType: 'password',
        clientId: '2_659vq9a3czggcws88wcws8s4kc8gc8gcss4wog4cwcsk08ggkg',
        clientSecret: '5ncmjzrt9ps8808cskk8ogwwgwkgks8ggc0kskg0cw48s08ks4',
        emailFocus: false,
        passwordFocus: false,
        loginInProgress: false,
        isError: false,
        loginErrorMessage: '',
        passwordType: 'password'
      },
      content: {
        title: '',
        description: '',
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: '',
          hideSection: false
        },
        stepSection: {
          description: '',
          steps: [
            {
              id: '',
              text: '',
              altImage: '',
              image: '',
              altImageHigh: '',
              imageHigh: ''
            }
          ],
          hideSection: false
        },
        textSection: [
          {
            title: '',
            text: '',
            altImage: '',
            image: ''
          }
        ],
        ctaSection: {
          title: '',
          hideSection: false
        }
      },
      initialContent: {
        heroSection: {
          title: '',
          description: '',
          altImage: '',
          image: ''
        },
        stepSection: {
          description: '',
          steps: [
            {
              id: '',
              text: '',
              altImage: '',
              image: '',
              altImageHigh: '',
              imageHigh: ''
            }
          ]
        },
        textSection: [
          {
            title: '',
            text: '',
            altImage: '',
            image: ''
          }
        ],
        ctaSection: {
          title: ''
        }
      },
      activePopup: null,
      stepImageChange: false,
      stepActive: 1,
      windowWidth: window.innerWidth,
      xDown: null,
      yDown: null,
      activatePage: false,
      topLoginInProgress: false,
      bottomLoginInProgress: false
    }
  },
  computed: {
    ...mapGetters([
      'getIsLoggedIn',
      'getUserRole',
      'selectedHightCont',
      'getSelectedFontSize'
    ])
  },
  methods: {
    ...mapActions([
      'redirect'
    ]),
    closeCustomMsg () {
      this.activatePage = false
      let query = Object.assign({}, this.$route.query)
      delete query.activated
      this.$router.replace({ query })
    },
    updateLandingPage () {
      if (this.disableAPI) return
      this.$validator.validateAll()
      if (this.errors.items.length) return
      let body = JSON.stringify(this.content)
      let pageData = {
        slug: 'login-page',
        body: body
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.getLandingPage()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    updateMeta () {
      if (this.disableAPI) return
      let metaTitle = this.metaData.title
      let metaDescription = this.metaData.description
      let pageData = {
        title: metaTitle,
        slug: 'login-page',
        description: metaDescription
      }
      this.disableAPI = true
      this.$http.post(api.URLS.staticpage, pageData, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        document.location.reload()
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    getLandingPage (id) {
      if (this.disableAPI) return
      this.disableAPI = true
      let body = {
        slug: 'login-page'
      }
      if (id) {
        body.id = id
      }
      this.$http.post(api.URLS.staticpage + '/login-page', body, api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        let pageData = JSON.parse(res.data.body)
        this.content = pageData
        this.metaData.title = res.data.title
        this.metaData.description = res.data.description
        if (this.metaData.title && this.metaData.title !== '') {
          document.title = this.metaData.title + ' | Clear Assured'
        }
        this.addPageMeta('description', [{name: 'content', value: this.metaData.description}])
        this.content.title = this.metaData.title
        this.content.description = this.metaData.description
        if (id) {
          this.pageEditSwitch()
        } else {
          this.pageEditMode = false
        }
        if (window.ga) {
          window.ga('set', 'contentGroup1', 'PUBLIC_PAGE')
          window.ga('send', 'pageview', {
            'page': location.pathname,
            'location': location.href,
            'title': document.title
          })
        }
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    removeWordFromString (word, phrase) {
      return phrase.replace(word, '')
    },
    getPageVersions () {
      let self = this
      if (this.disableAPI) return
      this.disableAPI = true
      this.$http.get(api.URLS.staticpagechanges + '/login-page', api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.pageVersions = []
        for (let index in res.body) {
          self.pageVersions.push({
            label: self.convertDateTime(res.body[index].createdAt),
            id: res.body[index].id
          })
        }
        this.editHistory = true
      }).catch((err) => {
        this.disableAPI = false
        console.log('err', err)
      })
    },
    activateEditHistory () {
      this.getPageVersions()
    },
    getPageVersionsForSelect () {
      return this.pageVersions
    },
    changeLandingPage (el) {
      this.getLandingPage(el.id)
    },
    convertDateTime (payload) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let ampm = hours >= 12 ? 'PM' : 'AM'
      let newHours = hours % 12 ? hours % 12 : 12
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      let dateString = toDoubleDigit(day) + '/' + toDoubleDigit(month) + '/' + fullYear
      let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
      return dateString + ' ' + timeString
    },
    addPageMeta (name, data) {
      let meta = document.createElement('meta')
      meta.name = name
      for (let index in data) {
        meta.setAttribute(data[index].name, data[index].value)
      }
      document.getElementsByTagName('head')[0].appendChild(meta)
    },
    discardChanges () {
      this.getLandingPage()
    },
    pageEditSwitch () {
      this.pageEditMode = true
      this.$nextTick(() => {
        this.autoSizeOnInit()
      })
    },
    discardPageEdit () {
      this.discardChanges()
      if (this.editHistory) {
        this.editHistory = false
      } else {
        this.landingPanel = false
      }
    },
    authenticate (form) {
      if (this.disableAPI) return
      let fields
      if (form === 'top') {
        this.topLoginForm.loginInProgress = true
        fields = ['TopEmail', 'TopPassword']
      } else {
        this.bottomLoginForm.loginInProgress = true
        fields = ['BottomEmail', 'BottomPassword']
      }
      this.$validator.validateAll(fields).then((valid) => {
        if (!valid) {
          if (form === 'top') {
            this.topLoginForm.loginInProgress = false
          } else {
            this.bottomLoginForm.loginInProgress = false
          }
          return
        }
        let auth
        if (form === 'top') {
          auth = {
            grant_type: this.topLoginForm.grantType,
            client_id: this.topLoginForm.clientId,
            client_secret: this.topLoginForm.clientSecret,
            username: this.topLoginForm.email,
            password: this.topLoginForm.password
          }
        } else {
          auth = {
            grant_type: this.bottomLoginForm.grantType,
            client_id: this.bottomLoginForm.clientId,
            client_secret: this.bottomLoginForm.clientSecret,
            username: this.bottomLoginForm.email,
            password: this.bottomLoginForm.password
          }
        }
        this.$http.post(api.URLS.login, auth).then((res) => {
          let headers = {headers: {'Authorization': `Bearer ${res.body.access_token}`}}
          document.cookie = 'Recite.Persist=; Max-Age=-99999999;'
          localStorage.setItem('token', res.body.access_token)
          this.$http.put(api.URLS.profile, {}, headers)
            .then((res) => {
              this.$store.commit('authLoginSuccess')
              let userData = {
                'id': res.body.id ? res.body.id : '',
                'firstName': res.body.first_name ? res.body.first_name : '',
                'lastName': res.body.last_name ? res.body.last_name : '',
                'userRole': res.body.role.slug,
                'company': res.body.company ? res.body.company.id : null
              }
              if (['ca', 'gm'].indexOf(res.body.role.slug) > -1 && res.body.consent_status === 0) {
                localStorage.setItem('consentHead', 'true')
              }
              localStorage.setItem('consentSeen', res.body.consent_seen)
              localStorage.setItem('userData', JSON.stringify(userData))
              localStorage.setItem('cookieFixed', true)
              localStorage.setItem('userIndustry', (res.body.company && res.body.company.industry) ? res.body.company.industry.id : 1)
              document.getElementById('app').setAttribute('data-industry', (res.body.company && res.body.company.industry) ? res.body.company.industry.id : 1)
              if (res.body.company) {
                localStorage.setItem('userCompanyName', res.body.company.name)
              }
              if (res.body.company && res.body.company.industry) {
                localStorage.setItem('userIndustryName', res.body.company.industry.name)
              }
              this.$store.commit('authLoginSetUsername', userData.firstName)
              this.redirect()
            })
            .catch((err) => {
              if (err.status === 401) {
                localStorage.removeItem('token')
                localStorage.removeItem('userData')
                localStorage.removeItem('consentSeen')
                localStorage.removeItem('consentHead')
                localStorage.removeItem('userIndustryName')
                localStorage.removeItem('userCompanyName')
                if (form === 'top') {
                  this.topLoginForm.isError = true
                  this.topLoginForm.loginInProgress = false
                  this.topLoginForm.loginErrorMessage = 'Your account is inactive. Please contact support.'
                } else {
                  this.bottomLoginForm.isError = true
                  this.bottomLoginForm.loginInProgress = false
                  this.bottomLoginForm.loginErrorMessage = 'Your account is inactive. Please contact support.'
                }
              }
            })
        }).catch((err) => {
          if (form === 'top') {
            this.topLoginForm.isError = true
            this.topLoginForm.loginInProgress = false
            this.topLoginForm.loginErrorMessage = 'Invalid credentials'
          } else {
            this.bottomLoginForm.isError = true
            this.bottomLoginForm.loginInProgress = false
            this.bottomLoginForm.loginErrorMessage = 'Invalid credentials'
          }
          console.log(err)
        })
      })
    },
    addSection (section) {
      section.push({
        title: '',
        text: '',
        image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM8VQ8AAhkBSxYn5M8AAAAASUVORK5CYII='
      })
    },
    removeSection (section, index) {
      section.splice(index, 1)
    },
    showPassword (form) {
      if (form === 'top') {
        this.topLoginForm.passwordType = this.topLoginForm.passwordType === 'password' ? 'text' : 'password'
      } else {
        this.bottomLoginForm.passwordType = this.bottomLoginForm.passwordType === 'password' ? 'text' : 'password'
      }
    },
    decodeHtml (value) {
      var txt = document.createElement('textarea')
      txt.innerHTML = value
      return txt.value
    },
    autoSize (el) {
      setTimeout(function () {
        el.target.style = 'height:auto; padding:0'
        el.target.style = 'height:' + el.target.scrollHeight + 'px'
      }, 0)
    },
    autoSizeOnInit () {
      let textAreas = document.getElementsByTagName('textarea')
      for (let i = 0; i < textAreas.length; i++) {
        let item = textAreas[i]
        setTimeout(function () {
          item.style = 'height:auto; padding:0'
          item.style = 'height:' + item.scrollHeight + 'px'
        }, 0)
      }
    },
    encodeHtml (rawStr) {
      return rawStr.replace(/[\u00A0-\u9999<>]/gim, function (i) {
        return '&#' + i.charCodeAt(0) + ';'
      })
    },
    isGM () {
      let isLogged = this.getIsLoggedIn
      if (!isLogged) {
        return false
      }
      let userRole = this.getUserRole
      if (userRole === 'gm') {
        return true
      }
      return false
    },
    onFileChange (e, target, item) {
      var input = e.target
      let self = this
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif|svg)$/i)) {
        var reader = new FileReader()
        reader.onload = function (e) {
          let fileName = input.files[0].name
          let extension = fileName.split('.').pop().toLowerCase()
          if (self.disableAPI) return
          let pageData = {
            file: e.target.result,
            extension: extension
          }
          self.disableAPI = true
          self.$http.post(api.URLS.uploadFile, pageData, api.headersAuthSettings).then((res) => {
            self.disableAPI = false
            target[item] = res.body
          }).catch((err) => {
            self.disableAPI = false
            console.log('err', err)
          })
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    getImagePath () {
      return api.serverURL + '/uploads/images/content/'
    },
    isBase64 (payload) {
      return payload.indexOf('data:') !== -1
    },
    getImage (payload) {
      if (!payload) {
        return ''
      }
      return this.isBase64(payload) ? 'url(' + payload + ')' : 'url(' + this.getImagePath() + payload + ')'
    },
    getImageFullPath (payload) {
      if (!payload) {
        return ''
      }
      return this.isBase64(payload) ? payload : this.getImagePath() + payload
    },
    handleWindowResize (event) {
      this.windowWidth = event.currentTarget.innerWidth
    },
    getDeviceType (check) {
      let width = this.windowWidth
      let deviceName = ''
      if (width > 940) {
        deviceName = 'desktop'
      } else if (width > 640) {
        deviceName = 'tablet'
      } else {
        deviceName = 'mobile'
      }
      return check === deviceName
    },
    activatePopup (step) {
      this.activePopup = step
    },
    closePopup () {
      this.activePopup = null
      this.pageMetaEdit = false
    },
    closePopupOnOutsideClick (e) {
      let popup = this.$refs.popup
      let target = e.target
      if (popup && popup !== target && !popup.contains(target)) {
        this.activePopup = null
      }
    },
    getHighImage (item) {
      return this.selectedHightCont === 1 ? item.imageHigh : item.image
    },
    handleTouchStart (evt) {
      this.xDown = evt.touches[0].clientX
      this.yDown = evt.touches[0].clientY
    },
    handleTouchMove (evt) {
      if (!this.xDown || !this.yDown) {
        return
      }
      if (!this.getDeviceType('mobile')) {
        return
      }
      let target = evt.target
      let steps = this.$refs.steps
      if (steps && steps !== target && steps.contains(target)) {
        let xUp = evt.touches[0].clientX
        let yUp = evt.touches[0].clientY
        let xDiff = this.xDown - xUp
        let yDiff = this.yDown - yUp
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
          if (xDiff > 0) {
            if (this.stepActive === 1) {
              this.stepActive = 3
            } else {
              this.stepActive -= 1
            }
          } else {
            if (this.stepActive === 3) {
              this.stepActive = 1
            } else {
              this.stepActive += 1
            }
          }
        }
        this.xDown = null
        this.yDown = null
      }
    }
  },
  beforeMount () {
    this.getLandingPage()
  },
  mounted () {
    window.addEventListener('resize', this.handleWindowResize)
    document.addEventListener('click', this.closePopupOnOutsideClick)
    document.addEventListener('touchstart', this.handleTouchStart, false)
    document.addEventListener('touchmove', this.handleTouchMove, false)
    this.activatePage = this.$route.query.activated
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
    document.addEventListener('click', this.closePopupOnOutsideClick)
    document.addEventListener('touchstart', this.handleTouchStart, false)
    document.addEventListener('touchmove', this.handleTouchMove, false)
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
  .inform-popup {
    margin-bottom: 15px;
    margin-top: 45px;
    max-width: 1270px;
  }
</style>

<style src="@/assets/scss/main/landing-page.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// Login.vue?730bdcf2